import {
  DagStatus,
  TaskAction,
  TerminationMode,
  isRunningStatus,
} from '@agilelab/plugin-wb-builder-common';
import {
  createActionsColumn,
  TableCellProps,
  WbButton,
  WbTable,
} from '@agilelab/plugin-wb-platform';
import { Box, Typography, useTheme } from '@material-ui/core';
import { FC, useEffect } from 'react';
import { useReleaseDetailPageContext } from '../../context/useReleaseDetailPageContext';
import { useStepIcons } from '../../hooks/useStepIcons';
import { Deploy } from '../../types';
import { ForceTerminateIcon } from './Icons';
import {
  createActionColumn,
  createDateColumn,
  createProcessColumn,
  createStatusColumn,
} from '../../utils/deploymentColumns';

import { LatestProvisioningActions } from './LatestProvisionigActions';

interface Props {
  deploy: Deploy;
  canProvision: boolean;
}

export const LatestProvisioningDetail: FC<Props> = ({
  deploy,
  canProvision,
}) => {
  const stepIcons = useStepIcons();
  const {
    isDeployingAll,
    isUndeployingAll,
    setIsDeployingAll,
    setIsUndeployingAll,
    terminateMode,
    terminate,
  } = useReleaseDetailPageContext();
  const theme = useTheme();

  const hide =
    isDeployingAll ||
    isUndeployingAll ||
    deploy.status !== DagStatus.TERMINATED;

  const cols: TableCellProps<Deploy>[] = [
    createActionColumn('Latest Action'),
    createDateColumn(),
    createStatusColumn(stepIcons),
    createProcessColumn(),
    createActionsColumn({
      width: 240,
      renderActions: row => (
        <LatestProvisioningActions deploy={row} canProvision={canProvision} />
      ),
    }),
  ];

  useEffect(() => {
    if (isRunningStatus(deploy.status)) {
      if (deploy.action === TaskAction.PROVISION) {
        setIsDeployingAll(true);
      }
      if (deploy.action === TaskAction.UNPROVISION) {
        setIsUndeployingAll(true);
      }
    }
  }, [deploy, setIsDeployingAll, setIsUndeployingAll]);

  return (
    <>
      <WbTable<Deploy>
        pinActionsColumnOnMobile={false}
        stickyHeader
        components={{
          tableContent: {
            columns: cols,
            rows: [deploy],
          },
        }}
      />
      {terminateMode === TerminationMode.SAFE &&
        deploy.status === DagStatus.RUNNING && (
          <Box
            padding={1}
            margin={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{
              backgroundColor: theme.palette.background.paper,
              gap: 16,
              marginTop: 16,
            }}
          >
            <Typography style={{ fontWeight: 600 }}>
              Process termination requestes.
            </Typography>
            <Typography>
              The operation may take some time, please wait. If the wait lasts
              longer than expected, click
            </Typography>
            <WbButton
              color="primary"
              size="small"
              icon={<ForceTerminateIcon />}
              onClick={_ => {
                terminate(TerminationMode.FORCED);
              }}
              variant="contained"
              style={{
                backgroundColor: theme.palette.error.main,
              }}
              label="Force Terminate"
            />
          </Box>
        )}

      {!hide && (
        <Box
          padding={1}
          margin={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: theme.palette.background.paper,
            gap: 16,
            marginTop: 16,
          }}
        >
          <Typography style={{ fontWeight: 600 }}>
            The process has been terminated.
          </Typography>
        </Box>
      )}
    </>
  );
};
